import { storeToRefs } from 'pinia';
import { getUrl } from '@/core/lib/url';
import type { PlayerType } from '@/interface/enum';
import { SportType } from '@/interface/enum';
import { useToggleStore } from '@/store/toggleStore';

export interface MultiProviderSportCustomerContext {
    sboCurrency: string;
    playerType: PlayerType;
}

export interface MultiProviderSportConfig {
    sboSportType: SportType;
    externalSportType: SportType;
    displaySportType: SportType;
    popupWindowName: string;
    getExternalUrl: () => string;
    isChildrenAvailable: (customer: MultiProviderSportCustomerContext) => boolean;
}

export const multiProviderSportConfigs: readonly MultiProviderSportConfig[] = [
    {
        sboSportType: SportType.Esports,
        externalSportType: SportType.EsportsIm,
        displaySportType: SportType.EsportsForDisplay,
        popupWindowName: 'ESportsIm',
        getExternalUrl: () => getUrl(__URL_ESPORTS_IM__),
        isChildrenAvailable: ({ sboCurrency }) => {
            const { isESportsImInSportEnabled, esportsNotAllowCurrencies } = storeToRefs(useToggleStore());
            return isESportsImInSportEnabled.value
                && !esportsNotAllowCurrencies.value.includes(sboCurrency);
        },
    },
    {
        sboSportType: SportType.MuayThai,
        externalSportType: SportType.MuayThaiOneBx,
        displaySportType: SportType.MuayThaiForDisplay,
        popupWindowName: 'MuayThaiONEBX',
        getExternalUrl: () => getUrl(__URL_MUAY_THAI_ONEBX__),
        isChildrenAvailable: ({ playerType }) => {
            const { isMuayThaiOneBxInSportEnabled, muayThaiOneBxAllowedPlayerTypes } = storeToRefs(useToggleStore());
            return isMuayThaiOneBxInSportEnabled.value
                && muayThaiOneBxAllowedPlayerTypes.value.includes(playerType);
        },
    },
];
